import { connect } from 'react-redux'
import AccountSettingsCard from '../components/AccountSettingsCard'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { getWord, WID } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  const { user } = state.authentication
  const { width } = state.window
  const { settings } = state.settings
  const { settings: accountSettings, error, result, isSaving } = state.accountSettingsCard
  const { avatarPhotoURL, headerPhotoURL, userName, displayName, rank, country, city, birthday, profileHTML } = accountSettings
  const { language } = state.user
  var disableSendButton = 
    !Object.keys({...accountSettings, ...ownProps.defaultValues}).some((key) => {
      return Boolean(
        ownProps.defaultValues[key] !== accountSettings[key] &&
        !(ownProps.defaultValues[key] === undefined && accountSettings[key] === '')
      )
    }) || Object.keys(error).some((key) => { return error[key] === true })

  return ({
    user,
    width,
    settings,
    avatarPhotoURL,
    headerPhotoURL,
    userName,
    displayName,
    rank,
    country,
    city,
    birthday,
    profileHTML,
    error,
    disableSendButton,
    result,
    isSaving,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(actions.accountSettingsCard.init(ownProps.defaultValues))
    },
    unmount: () => {
      dispatch(actions.accountSettingsCard.unmount())
    },
    handleChangePhoto: (name, data) => {
      dispatch(actions.accountSettingsCard.changedPhoto(name, data))
    },
    handleChangeText: (name) => (event) => {
      dispatch(actions.accountSettingsCard.changedText(name, event.target.value))
    },
    handleChangeTinyMCE: (content) => {
      dispatch(actions.accountSettingsCard.changedText('profileHTML', content))
    },
    handleSave: (values, language) => () => {
      var promiseUpload1, promiseUpload2, promiseUpdate, data
      data = {}
      Object.keys({...values, ...ownProps.defaultValues}).forEach((key) => {
        if (
          ownProps.defaultValues[key] !== values[key] &&
          !(ownProps.defaultValues[key] === undefined && values[key] === '')
        ) {
          data[key] = values[key]
        }
      })
      dispatch(actions.accountSettingsCard.startSave())
      promiseUpload1 = new Promise((resolve, reject) => {
        if (data.avatarPhotoURL) {
          dispatch(api.media.upload(
            'avatar',
            '#avatarPhotoURL',
            (response) => {
              dispatch(actions.accountSettingsCard.responseUploadAvatar(response))
              dispatch(actions.settings.responseUploadAvatar(response))
              resolve(response)
            }
          ))
        }
        else {
          resolve(null)
        }
      })
      delete data.avatarPhotoURL
      promiseUpload2 = new Promise((resolve, reject) => {
        if (data.headerPhotoURL) {
          dispatch(api.media.upload(
            'header',
            '#headerPhotoURL',
            (response) => {
              dispatch(actions.accountSettingsCard.responseUploadHeader(response))
              dispatch(actions.settings.responseUploadHeader(response))
              resolve(response)
            }
          ))
        }
        else {
          resolve(null)
        }
      })
      delete data.headerPhotoURL
      promiseUpdate = new Promise((resolve, reject) => {
        if (Object.keys(data).some((key) => data[key] !== undefined)) {
          dispatch(api.user.update(
            data,
            (response) => {
              dispatch(actions.accountSettingsCard.responseUpdate(
                response,
                Object.keys(data).filter((key) => data[key] !== undefined)
              ))
              dispatch(actions.settings.responseUpdate(response))
              resolve(response)
            }
          ))
        }
        else {
          resolve(null)
        }
      })
      Promise.all([promiseUpload1, promiseUpload2, promiseUpdate])
      .then((responseList) => {
        if (responseList.some((response) => {
          return Boolean(response !== null && response.result === false)
        })) {
          dispatch(actions.snackbar.notify(getWord(WID.ACCOUNT_SETTINGS_CARD.NOTIFY_UPDATE_FAILED, language), 'error'))
        }
        else {
          dispatch(actions.snackbar.notify(getWord(WID.ACCOUNT_SETTINGS_CARD.NOTIFY_UPDATE_COMPLETE, language), 'success'))
        }
        dispatch(actions.accountSettingsCard.endSave())
      })
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountSettingsCard)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/AccountSettingsCard.js